import PropTypes from "prop-types"
import React from "react"
import { connect } from "react-redux"

import InventoryTableModal from "areas/product/jewlr/modals/inventory-table-modal"
import ShippingInformationHalfModal from "areas/product/jewlr/modals/shipping-information"

import Shipping from "./shipping"

const InternalShippingInfo = ({ outOfStock }) => {
  if (outOfStock) return null

  return (
    <>
      <InventoryTableModal />
      <ShippingInformationHalfModal />
      <Shipping />
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    outOfStock: state.wizard.header?.product_out_of_stock,
  }
}

const mapDispatchToProps = () => {
  return {}
}

InternalShippingInfo.propTypes = {
  outOfStock: PropTypes.bool,
}

const ShippingInfo = connect(
  mapStateToProps,
  mapDispatchToProps
)(InternalShippingInfo)

export default ShippingInfo
